<div class="wrapper-auth-pages">
  <div class="wrapper-auth-left">
    <div class="wrapper-login-page">
      <div class="login-page login">
        <div class="wrapper-logo-auth">
          <img src="../assets/icons/logo-horizontal-yellow.svg" alt="">
        </div>
        <div class="info-auth-login">
          <h1 *ngIf="google">{{'LOGIN.sign_up_google' | translate}}</h1>
          <h6 *ngIf="google">{{'LOGIN.well_use_your_google_account_to_get_you_started' | translate}}</h6>
          <h1 *ngIf="!google">{{'LOGIN.sign_up_apple' | translate}}</h1>
          <h6 *ngIf="!google">{{'LOGIN.well_use_your_apple_account_to_get_you_started' | translate}}</h6>
        </div>

        <div class="auth-step-content-wrapper">
          <div class="login-form-container social-login">
            <div class=" social-wrap ">
              <img *ngIf="google" src="../../../../assets/icons/icon-google.svg" alt="">
              <img *ngIf="!google" src="../../../../assets/icons/icon-apple.svg" alt="">

              <div class="terms">
                <span>By clicking 'Continue' {{'CREATE_ACCOUNT.i_agree_to_the' | translate}}</span>
                <a class="tl-link xs-mr-4" href="javascript:void(0)" (click)="$event.stopPropagation()" [routerLink]="PAGES_AND_PATHS.termsAndConditionsPublic.pagePath">{{'CREATE_ACCOUNT.terms_of_service' | translate}},</a>
                <a class="tl-link xs-mr-4" (click)="$event.stopPropagation()" href="https://www.apple.com/legal/internet-services/itunes/dev/stdeula/">EULA (End User License Agreement)</a>
                <span>{{'CREATE_ACCOUNT.and' | translate}}</span>
                <a class="tl-link" href="javascript:void(0)" (click)="$event.stopPropagation()" [routerLink]="PAGES_AND_PATHS.privacyPolicy.pagePath">{{'CREATE_ACCOUNT.privacy_policy' | translate}}</a>
              </div>
            </div>

            <div class="overflow-wrap">
              <p *ngIf="google">
                I provide my personal data to TheLysts to create an TheLysts account, as described in the Privacy Notice. My registration cannot be completed without my data. As part of my relationship program, TheLysts will send me personalized  messages to inform me about my lists and activities based on my content and interactions with TheLysts. I can unsubscribe at any time.
              </p>
              <p *ngIf="google">
                I provide my personal data to TheLysts to create an TheLysts account, as described in the Privacy Notice. My registration cannot be completed without my data. As part of my relationship program, TheLysts will send me personalized  messages to inform me about my lists and activities based on my content and interactions with TheLysts. I can unsubscribe at any time.
              </p>
              <p *ngIf="!google">
                THESE TERMS OF SERVICE (“TERMS OF SERVICE” OR “AGREEMENT”) CONSTITUTE A LEGAL AGREEMENT AND ARE ENTERED INTO BETWEEN APPLE INC. (“APPLE”) AND THE PERSON OR ENTITY AGREEING TO THESE TERMS OF SERVICE BY, AND INCLUDING, SUCH ENTITY’S AUTHORIZED REPRESENTATIVE, INCLUDING EMPLOYEES, AGENTS, ASSIGNS, NOMINEES, CONSULTANTS, AND CONTRACTORS (INDIVIDUALLY OR COLLECTIVELY THE “BUSINESS”, “YOU” OR “YOUR”), AND GOVERNS YOUR ACCESS TO OR USE OF THE BUSINESS CONNECT SERVICES AND ANY RELATED DOCUMENTATION PROVIDED BY APPLE (I) ASSOCIATED WITH THE ACCOUNT
                CREATED, ACCESSED OR USED BY YOU IN CONNECTION WITH THESE TERMS OF SERVICE, OR (II) ANY OTHER SERVICES, PROGRAMS, OR PRODUCTS THAT INCORPORATE BY REFERENCE THESE TERMS OF SERVICE
              </p>
            </div>
          </div>
        </div>
      </div>
        <div class="wrapper-sign-up-company-fixed">
          <div class="wrapper-btn-sign-up-company">
            <a (click)="confirmSocial()">{{'NEW_TEXT.continue' | translate}}</a>
          </div>
        </div>
    </div>
  </div>
  <tl-onboarding-swipe class="wrapper-auth-right"></tl-onboarding-swipe>
</div>

